/* Studio Alyssum slide-out cart (replaces Monster Cart Upsell's drawer, no offers).
   - Opens from the header cart icon (any link to /cart) and after any successful
     /cart/add (theme jQuery AJAX or fetch), so the theme's existing add-to-cart,
     gift add-ons and gift message keep working unchanged.
   - Renders /cart.js; quantity +/- and remove use /cart/change.js. */
(function () {
  'use strict';

  var cfg = window.saCartConfig || {};
  var root = document.getElementById('SaCart');
  if (!root) return;

  var panel = root.querySelector('.sa-cart__panel');
  var itemsEl = root.querySelector('[data-sa-cart-items]');
  var emptyEl = root.querySelector('[data-sa-cart-empty]');
  var footerEl = root.querySelector('[data-sa-cart-footer]');
  var subtotalEl = root.querySelector('[data-sa-cart-subtotal]');
  var checkoutTotalEl = root.querySelector('[data-sa-cart-checkout-total]');
  var errorEl = root.querySelector('[data-sa-cart-error]');
  var hidden = (cfg.hiddenVariantIds || []).map(String);
  var lastFocus = null;
  var busy = false;

  // Backup mode: while the Monster Cart Upsell app is installed and running, this
  // drawer stays dormant and Monster handles the cart. If Monster is absent, or it
  // shuts itself off (it sets window.upsellCartStopped when its server fails),
  // this drawer takes over automatically.
  function monsterActive() {
    return !!window.mu_version && !window.upsellCartStopped;
  }

  // ---------- helpers ----------
  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    function withDelims(num, dec, thou, sep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec ? sep : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function img(url, size) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + size + '$1$2');
  }

  function visibleItems(cart) {
    return cart.items.filter(function (i) { return hidden.indexOf(String(i.variant_id)) === -1; });
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = !msg;
    if (msg) setTimeout(function () { errorEl.hidden = true; }, 5000);
  }

  // ---------- header count ----------
  function updateCount(cart) {
    var count = visibleItems(cart).reduce(function (n, i) { return n + i.quantity; }, 0);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (el) {
      el.classList.toggle('hide', count === 0);
      el.classList.toggle('show', count > 0);
    });
  }

  // ---------- render ----------
  function render(cart) {
    var items = visibleItems(cart);
    updateCount(cart);

    if (!items.length) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footerEl.hidden = false;

    itemsEl.innerHTML = items.map(function (item) {
      var line = cart.items.indexOf(item) + 1;
      var variant = item.product_has_only_default_variant ? '' :
        (item.options_with_values || []).map(function (o) { return esc(o.value); }).join(' / ');
      var props = Object.keys(item.properties || {}).filter(function (k) {
        var v = item.properties[k];
        return k.charAt(0) !== '_' && v !== '' && v != null;
      }).map(function (k) {
        return '<li><span>' + esc(k) + ':</span> ' + esc(item.properties[k]) + '</li>';
      }).join('');
      var compare = item.original_line_price > item.final_line_price ?
        '<s class="sa-cart__compare">' + money(item.original_line_price) + '</s>' : '';
      var image = item.image ?
        '<img src="' + esc(img(item.image, '160x')) + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">' : '';

      return '' +
        '<li class="sa-cart__item" data-line="' + line + '" data-key="' + esc(item.key) + '">' +
          '<a class="sa-cart__img" href="' + esc(item.url) + '">' + image + '</a>' +
          '<div class="sa-cart__info">' +
            '<div class="sa-cart__row">' +
              '<a class="sa-cart__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              '<button type="button" class="sa-cart__remove" data-sa-remove aria-label="Remove ' + esc(item.product_title) + '">' +
                '<svg width="14" height="16" viewBox="0 0 14 16" aria-hidden="true"><path d="M1 4h12M5 4V2h4v2M3 4l1 10h6l1-10" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>' +
              '</button>' +
            '</div>' +
            (variant ? '<p class="sa-cart__variant">' + variant + '</p>' : '') +
            (props ? '<ul class="sa-cart__props">' + props + '</ul>' : '') +
            '<div class="sa-cart__row sa-cart__row--bottom">' +
              '<div class="sa-cart__qty">' +
                '<button type="button" data-sa-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span aria-live="polite">' + item.quantity + '</span>' +
                '<button type="button" data-sa-qty="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="sa-cart__price">' + compare + '<span>' + money(item.final_line_price) + '</span></div>' +
            '</div>' +
          '</div>' +
        '</li>';
    }).join('');

    var total = money(cart.total_price);
    subtotalEl.textContent = total;
    checkoutTotalEl.textContent = total;
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function change(key, quantity) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
          return data;
        });
      })
      .then(render)
      .catch(function (err) { showError(err.message); return refresh(); })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  // ---------- open / close ----------
  function open() {
    if (root.classList.contains('is-open')) { refresh(); return; }
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sa-cart-locked');
    refresh();
    setTimeout(function () { panel.focus(); }, 50);
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sa-cart-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // ---------- events inside the drawer ----------
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-sa-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (t.closest('[data-sa-cart-checkout]')) {
      e.preventDefault();
      t.closest('[data-sa-cart-checkout]').classList.add('is-loading');
      window.location.href = '/checkout';
      return;
    }
    var itemEl = t.closest('.sa-cart__item');
    if (!itemEl) return;
    var key = itemEl.getAttribute('data-key');
    var qtyBtn = t.closest('[data-sa-qty]');
    if (qtyBtn) {
      var current = parseInt(itemEl.querySelector('.sa-cart__qty span').textContent, 10) || 0;
      change(key, Math.max(0, current + parseInt(qtyBtn.getAttribute('data-sa-qty'), 10)));
    } else if (t.closest('[data-sa-remove]')) {
      change(key, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // ---------- open from any link to the cart (capture, so nothing else navigates) ----------
  function isCartLink(a) {
    if (!a || !a.getAttribute) return false;
    if (a.closest('#SaCart')) return false;
    var href = a.getAttribute('href') || '';
    return /^(https?:\/\/[^\/]+)?\/cart\/?(\?.*)?(#.*)?$/.test(href);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!isCartLink(a)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (monsterActive()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  // ---------- open after any successful add to cart ----------
  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }

  // theme code uses jQuery $.ajax
  function hookJquery() {
    var $ = window.jQuery;
    if (!$ || hookJquery.done) return;
    hookJquery.done = true;
    $(document).ajaxComplete(function (_e, xhr, settings) {
      if (!isAdd(settings && settings.url)) return;
      if (monsterActive()) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        open();
      } else {
        var msg = 'Sorry, that item could not be added.';
        try { msg = JSON.parse(xhr.responseText).description || msg; } catch (err) {}
        open();
        showError(msg);
      }
    });
  }
  hookJquery();
  document.addEventListener('DOMContentLoaded', hookJquery);
  window.addEventListener('load', hookJquery);

  // apps or newer code using fetch
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = nativeFetch.apply(this, arguments);
      if (isAdd(url)) {
        p.then(function (r) { if (r.ok && !monsterActive()) open(); }).catch(function () {});
      }
      return p;
    };
  }

  // /cart redirects home in this theme; /#cart (or ?cart=open) opens the drawer
  if ((location.hash === '#cart' || /[?&]cart=open/.test(location.search)) && !monsterActive()) {
    open();
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search.replace(/[?&]cart=open/, ''));
  }

  // public hooks for theme code
  window.SaCart = { open: open, close: close, refresh: refresh };
  // older theme code calls monster_refresh(open, callback) after adding to cart
  if (!window.mu_version && typeof window.monster_refresh !== 'function') {
    window.monster_refresh = function (shouldOpen, cb) {
      (shouldOpen ? (open(), refresh()) : refresh()).then(function () { if (cb) cb(); });
    };
  }

  // keep the header count correct on load
  refresh().catch(function () {});
})();
